import {
  COMPENSATION_SUMMARY_ROLE_IDS,
  ERP_LEAVE_IMPORT_ROLE_IDS,
  RoleID,
  OVERLOAD_MEMO_ADMIN_ROLE_IDS,
  OVERLOAD_MEMO_REVIEW_ROLE_IDS,
  SCHEDULE_CORRECTION_REQUEST_REVIEW_ROLE_IDS,
  SUBJECT_MANAGEMENT_EDIT_ROLE_IDS,
  SUBJECT_MANAGEMENT_ROLE_IDS,
  SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
  SUBJECT_SCHEDULE_ROLE_IDS,
  TEACH_COMPENSATION_MANAGEMENT_ROLE_IDS,
  TEACH_COMPENSATION_ROLE_IDS,
  TEACH_COMPENSATION_REPORT_ROLE_IDS,
  TEACH_COMPENSATION_REVIEW_ROLE_IDS,
  DISBURSEMENT_CERTIFY_ROLE_IDS,
  DISBURSEMENT_DOCUMENT_VIEW_ROLE_IDS,
  DISBURSEMENT_MANAGEMENT_ROLE_IDS,
  DISBURSEMENT_REVISION_REVIEW_ROLE_IDS,
} from "src/utils/enum/role.enum";
import { CoreMenuItem } from "./core-menu";

export const SYSTEM_NAVIGATION_MENU: CoreMenuItem[] = [
  //Component menu

  {
    title: "การตั้งค่า",
    icon: "setting-2",
    type: "accordion",
    role: [RoleID.ADMIN],

    classes: "settings-menu-group",
    children: [
      {
        title: "ช่วงเวลาการศึกษา",
        icon: "",
        url: "/settings/study-period",
        type: "item",
      },
      {
        title: "วันหยุดราชการ",
        icon: "",
        url: "/settings/pubblic-holiday",
        type: "item",
      },
      {
        title: "สาขาวิชา",
        icon: "",
        url: "/settings/departments",
        type: "item",
      }, {
        title: "หลักสูตร",
        icon: "",
        url: "/settings/curriculum-types",
        type: "item",
      }, {
        title: "ผู้ใช้งาน",
        icon: "",
        url: "/settings/users-management",
        type: "item",
      }, {
        title: "บันทึกข้อความขอสอนเกินภาระงาน",
        icon: "",
        url: "/settings/overload-memo",
        type: "item",
        role: OVERLOAD_MEMO_ADMIN_ROLE_IDS,
      },
      {
        // Admin sees รายวิชา nested here (inherits the accordion's [ADMIN] gate).
        // Officer/Head can't see this admin-only accordion — they get the
        // standalone item below instead.
        title: "รายวิชา",
        icon: "",
        url: "/settings/subject",
        type: "item",
      },
    ],
  },

  {
    // Standalone master-data entry for the non-admin master-data roles
    // (academic_officer + head_of_education). Admin is intentionally excluded
    // here to avoid a duplicate — admin sees รายวิชา under การตั้งค่า above.
    title: "รายวิชา",
    url: "/settings/subject",
    icon: "book",
    type: "item",
    role: SUBJECT_MANAGEMENT_EDIT_ROLE_IDS,
    classes: "settings-menu-group",
  },
  {
    title: "MENU.SUBJECT_MANAGEMRNT",
    url: "/subject-management",
    icon: "notepad",
    type: "item",
    role: SUBJECT_MANAGEMENT_ROLE_IDS,
    classes: "settings-menu-group",
  },
  {
    title: "การจัดการตารางสอน",
    url: "/schedule-submissions-management",
    icon: "calendar",
    type: "accordion",
    role: SUBJECT_SCHEDULE_ROLE_IDS,
    classes: "settings-menu-group",
    children: [
      {
        title: "ตารางสอน",
        icon: "",
        url: "/schedule-submissions-management/schedule-submissions",
        type: "item",
      },
      {
        title: "ตรวจสอบและรับรองตารางสอน",
        icon: "",
        url: "/schedule-submissions-management/schedule-submissions-review",
        type: "item",
        role: SUBJECT_SCHEDULE_REVIEW_ROLE_IDS,
      },
      {
        title: "ตรวจสอบคำขอแก้ไขกรณีพิเศษ",
        icon: "",
        url: "/schedule-submissions-management/schedule-correction-requests-review",
        type: "item",
        role: SCHEDULE_CORRECTION_REQUEST_REVIEW_ROLE_IDS,
      },
    ],
  },
  // {
  //   title: "Dashboard Summary",
  //   url: "/compensation-summary-dashboard",
  //   icon: "chart-simple",
  //   type: "item",
  //   role: COMPENSATION_SUMMARY_ROLE_IDS,
  //   classes: "settings-menu-group",
  // },
  {
    title: "MENU.TEACH_COMPENSATION",
    url: "/teach-compensation-management",
    icon: "calendar",
    type: "accordion",
    role: TEACH_COMPENSATION_MANAGEMENT_ROLE_IDS,
    classes: "settings-menu-group",
    children: [
      {
        title: "MENU.TEACH_COMPENSATION_REQUEST",
        icon: "",
        url: "/teach-compensation-management/teach-compensation",
        type: "item",
        role: TEACH_COMPENSATION_ROLE_IDS,
      },
      {
        title: "ตรวจสอบและรับรองคำขอสอนชดเชย",
        icon: "",
        url: "/teach-compensation-management/teach-compensation-review",
        type: "item",
        role: TEACH_COMPENSATION_REVIEW_ROLE_IDS,
      },
      {
        title: "รายงานคำขอสอนชดเชย",
        icon: "",
        url: "/teach-compensation-management/teach-compensation-report",
        type: "item",
        role: TEACH_COMPENSATION_REPORT_ROLE_IDS,
      },
      {
        title: "สรุปค่าสอนเกินภาระงาน",
        icon: "",
        url: "/teach-compensation-management/compensation-summary",
        type: "item",
        role: COMPENSATION_SUMMARY_ROLE_IDS,
      },
      {
        title: "นำเข้าวันลาจากระบบ ERP",
        icon: "",
        url: "/teach-compensation-management/erp-leave-import",
        type: "item",
        role: ERP_LEAVE_IMPORT_ROLE_IDS,
      },
    ],
  },
  {
    title: "การจัดการบันทึกข้อความ",
    url: "/teach-compensation-management/overload-memo-review",
    icon: "document",
    type: "accordion",
    role: OVERLOAD_MEMO_REVIEW_ROLE_IDS,
    classes: "settings-menu-group",
    children: [
      {
        title: "ตรวจสอบบันทึกข้อความขอสอนเกินภาระงาน",
        icon: "",
        url: "/teach-compensation-management/overload-memo-review",
        type: "item",
        role: OVERLOAD_MEMO_REVIEW_ROLE_IDS,
      },
    ],
  },
  {
    // จัดการเอกสารส่งเบิก — v1.2, UAM r21/r22 exact wording.
    title: "จัดการเอกสารส่งเบิก",
    url: "/disbursement-management/registry",
    icon: "dollar",
    type: "accordion",
    role: DISBURSEMENT_MANAGEMENT_ROLE_IDS,
    classes: "settings-menu-group",
    children: [
      {
        // r21 — merged display page for all six VE roles.
        title: "ข้อมูลเอกสารส่งเบิก",
        icon: "",
        url: "/disbursement-management/registry",
        type: "item",
        role: DISBURSEMENT_DOCUMENT_VIEW_ROLE_IDS,
      },
      {
        // r22 — UV x5 (VE minus สารบัญ), incl. vice_dean_academic's
        // revision-review queue.
        title: "ตรวจสอบและอนุมัติเอกสารส่งเบิก",
        icon: "",
        url: "/disbursement-management/disbursement-certification",
        type: "item",
        role: Array.from(new Set([
          ...DISBURSEMENT_CERTIFY_ROLE_IDS,
          ...DISBURSEMENT_REVISION_REVIEW_ROLE_IDS,
        ])),
      },
    ],
  },

];
